(function () {
    'use strict';

    angular
        .module('businessPlanModule')
        .factory('planInitiativeSelectionService', service);

    service.$inject = ['adminGovernanceProcessService', 'businessPlanningService', 'notificationService', 'searchV2Service'];

    function service(adminGovernanceProcessService, businessPlanningService, notificationService, searchV2Service) {
        return {
            init: function () {
                var srv = {
                    itemSelectionChanged: function (item, isSelected) {
                        if (isSelected) {
                            this.selectedItems.push(item.PlanInitiativeID);

                            // Update All Selected Checkbox
                            if (this.selectedItems.length === this.searchSource.numFound) {
                                this.isAllSelected = true;
                            }
                        } else {
                            var idx = this.selectedItems.indexOf(item.PlanInitiativeID);
                            this.selectedItems.splice(idx, 1);

                            // Update All Selected checkbox
                            this.isAllSelected = false;
                        }
                    },

                    cancelMode: function () {
                        this.clearSelection();
                        this.selectionMode = false;

                        if (this.onCancelMode) {
                            this.onCancelMode.apply(this);
                        }
                    },

                    // TODO Unused for the moment but feature should arrive soon
                    //createAssessments: function () {
                    //    // Check if active GovProc
                    //    grcGovernanceProcessService
                    //        .getActiveInitiativeUpdateStatus()
                    //        .then(function (activeGovProc) {
                    //            if (!activeGovProc) {
                    //                // Create gov proc from modal
                    //                var modal = modalService.displayTemplateModal(
                    //                    'Create an Initiative Status Update Governance Process',
                    //                    '/app/shared/grc/businessPlanning/initiative/govProcEditModal.tpl.html',
                    //                    {
                    //                        ngStyle: {overflow: 'visible', 'min-height': 'auto'},
                    //                        govProcess: {}
                    //                    },
                    //                    function (scope, form) {
                    //                        if (form.$invalid) return false;
                    //
                    //                        createGovernanceProcess(scope.govProcess)
                    //                            .then(function (createdProcess) {
                    //                                if (createdProcess) {
                    //                                    modal.hide();
                    //                                    createAssessmentOnGovProc(createdProcess);
                    //                                }
                    //                            });
                    //
                    //                    })
                    //            } else {
                    //                createAssessmentOnGovProc(activeGovProc);
                    //            }
                    //        });
                    //},

                    unlockInitiatives: function () {
                        srv.isLoading = true;
                        var successCount = 0;
                        var failedCount = 0;

                        // Separate each query to have the count and details on each failure
                        _.each(srv.selectedItems, function (initiativeId) {
                            businessPlanningService
                                .unlockInitiative(initiativeId)
                                .then(function () {
                                    successCount++;

                                    if ((successCount + failedCount) === srv.selectedItems.length) {
                                        onPromisesCompleted();
                                    }
                                })
                                .catch(function () {
                                    failedCount++;

                                    if ((successCount + failedCount) === srv.selectedItems.length) {
                                        onPromisesCompleted();
                                    }
                                })
                        });

                        function onPromisesCompleted() {
                            if (failedCount > 0) {
                                notificationService
                                    .warn(failedCount + ' ' + srv.getPluralizedLabel(failedCount) + ' couldn\'t be unlocked');
                            } else {
                                notificationService
                                    .notify(successCount + ' ' + srv.getPluralizedLabel(successCount) + ' unlocked successfully');
                            }

                            srv.isLoading = false;
                        }
                    },

                    clearSelection: function () {
                        this.selectedItems.length = 0;
                        this.isAllSelected        = false;
                    },

                    selectAllChanged: function () {
                        var queryParams = searchV2Service.getQueryParams(srv.sourceTypeConfig);

                        // Select All
                        if (srv.isAllSelected) {
                            srv.isLoading = true;
                            businessPlanningService
                                .getAllFoundPlanInitiativeIDs(queryParams)
                                .then(function (selectedIds) {
                                    srv.selectedItems = selectedIds;
                                })
                                .finally(function () {
                                    srv.isLoading = false;
                                });
                        } else {
                            srv.clearSelection();
                        }
                    },

                    // Called when search results have changed
                    resultsChanged: function () {
                        srv.clearSelection();
                    },

                    getPluralizedLabel: function (nbItems) {
                        return nbItems === 1 ? this.labelSingular  : this.labelPlural
                    },

                    labelSingular: 'initiative',
                    labelPlural: 'initiatives',
                    selectionMode: true,
                    selectedItems: [],
                    mode: 'manageInitiatives',
                    isLoading: false,
                    isAllSelected: false,
                    sourceTypeConfig: searchV2Service.getSourceTypeConfig('PlanInitiative')
                };

                Object.defineProperty(srv, 'label', {
                    get: function () {
                        return this.selectedItems.length === 1 ? this.labelSingular : this.labelPlural;
                    }
                });

                function createGovernanceProcess(govProcess) {
                    return adminGovernanceProcessService.createProcess(govProcess);
                }

                function createAssessmentOnGovProc() {
                    srv.isLoading = true;
                    businessPlanningService
                        .createAssessmentsForPlanInitiatives(srv.selectedItems)
                        .then(function () {
                            var msg = 'Assessments created successfully for ' + srv.selectedItems.length + ' ' + srv.label;
                            notificationService.notify(msg);
                        })
                        .finally(function () {
                            srv.isLoading = false;
                        });
                }

                return srv;
            }
        }
    }
})();